const ASSET_TYPE_KEY = 'Asset Type';

export const ASSET_TYPE_VALUES = {
  Undefined: 'Undefined',
  Tool: 'Tool',
  Accessory: 'Accessory',
  Material: 'Material',
  Storage: 'Storage'
};

export const ASSET_TYPE_ATTRIBUTE = {
  dataType: 'Text',
  freeform: false,
  key: ASSET_TYPE_KEY,
  id: ASSET_TYPE_KEY,
  values: Object.keys(ASSET_TYPE_VALUES).map(key => ({value: ASSET_TYPE_VALUES[key]}))
};
